import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ImageGalleryComponent } from "../image-gallery/image-gallery.component";

@Component({
  selector: 'app-client',
  standalone: true,
  imports: [CommonModule,ImageGalleryComponent],
  templateUrl: './client.component.html',
  styleUrl: './client.component.scss'
})
export class ClientComponent implements OnInit {
  public clientImages!: { image: string , routeLink: string}[]

  ngOnInit(): void {
   
    this.clientImages = [
      { 
        image:"../../assets/clientImage1.jpg",
        routeLink:"https://www.google.com/webhp?hl=en&sa=X&ved=0ahUKEwi0uN-bsbmOAxWVRmwGHYNECBQQPAgI",
      },
      { 
        image:"../../assets/clientImage2.jpg",
        routeLink:"https://www.google.com/webhp?hl=en&sa=X&ved=0ahUKEwi0uN-bsbmOAxWVRmwGHYNECBQQPAgI",
      },
      { 
        image:"../../assets/clientImage3.jpg",
        routeLink:"https://www.google.com/webhp?hl=en&sa=X&ved=0ahUKEwi0uN-bsbmOAxWVRmwGHYNECBQQPAgI",
      },
      { 
        image:"../../assets/clientImage1.jpg",
        routeLink:"https://www.google.com/webhp?hl=en&sa=X&ved=0ahUKEwi0uN-bsbmOAxWVRmwGHYNECBQQPAgI",
      },
      { 
        image:"../../assets/clientImage2.jpg",
        routeLink:"https://www.google.com/webhp?hl=en&sa=X&ved=0ahUKEwi0uN-bsbmOAxWVRmwGHYNECBQQPAgI",
      },
      { 
        image:"../../assets/clientImage3.jpg",
        routeLink:"https://www.google.com/webhp?hl=en&sa=X&ved=0ahUKEwi0uN-bsbmOAxWVRmwGHYNECBQQPAgI",
      },
      { 
        image:"../../assets/clientImage1.jpg",
        routeLink:"https://www.google.com/webhp?hl=en&sa=X&ved=0ahUKEwi0uN-bsbmOAxWVRmwGHYNECBQQPAgI",
      },
      { 
        image:"../../assets/clientImage2.jpg",
        routeLink:"https://www.google.com/webhp?hl=en&sa=X&ved=0ahUKEwi0uN-bsbmOAxWVRmwGHYNECBQQPAgI",
      },
      { 
        image:"../../assets/clientImage3.jpg",
        routeLink:"https://www.google.com/webhp?hl=en&sa=X&ved=0ahUKEwi0uN-bsbmOAxWVRmwGHYNECBQQPAgI",
      },
      { 
        image:"../../assets/clientImage1.jpg",
        routeLink:"https://www.google.com/webhp?hl=en&sa=X&ved=0ahUKEwi0uN-bsbmOAxWVRmwGHYNECBQQPAgI",
      },
      { 
        image:"../../assets/clientImage2.jpg",
        routeLink:"https://www.google.com/webhp?hl=en&sa=X&ved=0ahUKEwi0uN-bsbmOAxWVRmwGHYNECBQQPAgI",
      },
      { 
        image:"../../assets/clientImage3.jpg",
        routeLink:"https://www.google.com/webhp?hl=en&sa=X&ved=0ahUKEwi0uN-bsbmOAxWVRmwGHYNECBQQPAgI",
      },
  ]

  }


}
